<div class="grid bg-white" style="width: 500px">
  <div class="mb-5 flex items-center justify-start space-x-2 font-bold text-aux-green-dark">
    <aux-icon name="Check" />
    <span class="text-3xl">Change Order Approved!</span>
  </div>

  <span class="mb-5 text-xl text-aux-black">
    Would you like to check/modify any of the following that may be impacted?
  </span>
  <div class="aux-link flex flex-col space-y-2 text-xl">
    <div><span class="cursor-pointer" (click)="goFM()">1. Forecast Methodology</span></div>
    <div><span class="cursor-pointer" (click)="goTimeline()">2. Timeline</span></div>
    <div><span class="cursor-pointer" (click)="goExpenseDetail()">3. Vendor Estimates</span></div>
  </div>
</div>
